import { Icon } from "@chakra-ui/react";
import React from "react";

export default function Returns(props) {
  return (
    <Icon
      width="52px"
      height="52px"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.65192 5.77821C11.6096 2.2665 16.7194 0.331132 22.0104 0.339873C33.9769 0.339873 43.6771 10.04 43.6771 22.0065C43.6847 26.4351 42.3283 30.7585 39.7923 34.389L33.9271 22.0065H39.3438C39.3442 18.56 38.3172 15.1915 36.3939 12.3314C34.4706 9.47142 31.7383 7.24969 28.5461 5.95012C25.354 4.65055 21.8468 4.33214 18.4728 5.03556C15.0988 5.73899 12.011 7.43232 9.60408 9.89921L7.65192 5.77821ZM36.3667 38.2349C32.4097 41.7461 27.3007 43.6814 22.0104 43.6732C10.0439 43.6732 0.34375 33.973 0.34375 22.0065C0.34375 17.4024 1.78025 13.134 4.22858 9.62404L10.0938 22.0065H4.67708C4.67746 25.4525 5.70495 28.8201 7.62832 31.6793C9.55169 34.5386 12.2836 36.7596 15.4753 38.0588C18.6669 39.358 22.1734 39.6764 25.5468 38.9734C28.9203 38.2703 32.0076 36.5777 34.4146 34.1117L36.3667 38.2349ZM25.0763 28.1317L18.9489 22.0044L12.8194 28.1317L9.75575 25.068L18.9489 15.8749L25.0763 22.0044L31.2036 15.8749L34.2694 18.9407L25.0763 28.1317Z"
        fill="#AB7D00"
      />
    </Icon>
  );
}
